
import { Component, Vue } from 'vue-property-decorator';
import OrderSearch from './components/OrderSearchCustom.vue';
import OrderList from './components/OrderList.vue';
import { ViewType, OrderServiceStage } from '@/types/orderServicer';
import eventBus from '@/utils/eventBus';
import { UserModule } from "@/store/modules/user";

@Component({
  name: 'orderServicerCompleted',
  components: {
    OrderSearch,
    OrderList
  }
})
export default class extends Vue {
  private stage = OrderServiceStage.SERVICE_STAGE_FINISH;
  private vt = ViewType.ORDER_SERVICER_COMPLETED;

  get hasSearchParams() {
    const query = this.$route.query;
    return !!(query.fault_id || query.phenomenon_id || query.order_service_finish_state || query.finish_start_time || query.finish_end_time);
  }

  mounted() {
    this.handleRouteParams();
  }

  private handleRouteParams() {
    const query = this.$route.query;
    if (query.fault_id || query.phenomenon_id || query.order_service_finish_state || query.finish_start_time || query.finish_end_time) {
      const params: any = {
        user_id: UserModule.getUserId,
        company_id: UserModule.getCompanyId ? UserModule.getCompanyId : "0",
      };

      if (query.fault_id) {
        params.fault_id = query.fault_id;
      }

      if (query.phenomenon_id) {
        params.fault_phenomenon_id = query.phenomenon_id;
      }

      if (query.order_service_finish_state) {
        params.order_service_finish_state = query.order_service_finish_state;
      }

      if (query.finish_start_time) {
        params.finish_start_time = query.finish_start_time;
      }

      if (query.finish_end_time) {
        params.finish_end_time = query.finish_end_time;
      }

      setTimeout(() => {
        eventBus.$emit("orderServicerOrderSearch", params);
      }, 300);
    }
  }
}
